import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './needs-goals-item.component.scss';
var NeedsGoalsItem = /** @class */ (function (_super) {
    tslib_1.__extends(NeedsGoalsItem, _super);
    function NeedsGoalsItem(element) {
        return _super.call(this, element) || this;
    }
    NeedsGoalsItem.prototype.init = function () { };
    ;
    NeedsGoalsItem.prototype.bindEvents = function () { };
    ;
    return NeedsGoalsItem;
}(Base));
export { NeedsGoalsItem };



//////////////////
// WEBPACK FOOTER
// ./components/needs-goals-item/needs-goals-item.component.ts
// module id = 415
// module chunks = 0